export default {
  data() {
    return {
      submitted: false,
    };
  },
  computed: {
    hasErrors() {
      const errors = Object.keys(this.errors).filter(field => this.getErrors(field).length > 0);
      if (errors.length > 0) {
        return false;
      }
      return null;
    },
  },
  watch: {
    model() {
      if (this.submitted) {
        this.checkForm();
      }
    },
  },
  methods: {
    _resolve(path, obj) {
      return path.split('.').reduce((prev, curr) => (prev ? prev[curr] : null), obj || this);
    },
    callValidationFunctions(field, validation) {
      switch (validation) {
        case 'equals':
          this.errors[field].equals = this.isEquals(field, this.errors[field].field);
          break;
        case 'required':
        default:
          this.errors[field].required = this.isRequired(field);
          break;
      }
    },
    checkFields() {
      Object.keys(this.errors).forEach(field => {
        Object.keys(this.errors[field]).forEach(validation => {
          this.callValidationFunctions(field, validation);
        });
      });
    },
    checkForm() {
      this.submitted = true;
      this.checkFields();
      if (this.hasErrors == null) {
        return true;
      }
      return false;
    },
    getErrors(field) {
      return Object.keys(this.errors[field]).filter(error => this.errors[field][error] === true);
    },
    getInput(field) {
      if (this.model[field] === undefined) {
        if (this.errors[field].field) {
          return this._resolve(this.errors[field].field, this.model);
        }
        return field;
      }
      return this.model[field];
    },
    hasErrorFiled(field = 'name') {
      if (this.submitted) {
        if (this.getErrors(field).length) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
    isEquals(field, otherField) {
      const input = this.getInput(field);
      const otherInput = this.getInput(otherField);
      if (input === otherInput && (input !== null || input !== '')) {
        return false;
      }
      return true;
    },
    isRequired(field) {
      const input = this.getInput(field);
      if (!input || input === '') {
        return true;
      }
      return false;
    },
  },
};
